import { useEffect } from 'react'
import websocket from '@/utils/websocket'

const WebSocketConnectionAlertBridge = () => {
  useEffect(() => {
    const profile = localStorage.getItem('profile')
    if (!profile) {
      return undefined
    }

    websocket.connect()
  }, [])

  return null
}

export default WebSocketConnectionAlertBridge
